<template>
  <section class="commercial-returns-form">
    <former-alert
      class="commercial-return-alert"
      type="warning"
    >
      {{ messageAlert }}
    </former-alert>

    <commercial-form
      :loading="loading"
      :sections="sections"
      :selected-store="selectedStore"
      :rule="financingReturnRules.read.item"
      remove-action="financingReturnRules/delete"
      @submit="verifyOverlap"
      @removed="removed"
    />

    <popup-confirm
      v-if="popup"
      title="Confirmação"

      :loading="loading"

      confirm-button-label="Salvar regra"
      cancel-button-label="Não salvar"

      @close="close"
      @confirm="submit"
    >
      <template>
        <p class="former-section-popup-message">
          {{ messagePopupConfirmation }}
          <b>{{ overlappingRules[0].store.name }}: </b>
        </p>

        <div class="former-section-popup-wrapper">
          <ul>
            <li
              v-for="(overlappingRule, index) in overlappingRules"
              :key="overlappingRule.id"
              class="former-section-popup-list-item"
            >
              {{ overlappingRuleText(overlappingRule, index) }}
            </li>
          </ul>
        </div>
      </template>
    </popup-confirm>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import former from '@/helpers/mixins/former';
  import scrollHelper from '@/helpers/views/scroll';
  import FormerAlert from '@/components/Former/Alert.vue';
  import PopupConfirm from '@/components/Popup/Confirm.vue';

  import { stringify } from '@/helpers/filters';

  import {
    prioritiesSections as sections,
  } from '@/views/Settings/Commercial/Form/sections';

  import commercialMap, {
    storesMap,
    returnsMap,
  } from '@/views/Settings/Commercial/Form/maps';

  import CommercialForm from '@/views/Settings/Commercial/Form.vue';

  export default {
    name: 'CommercialReturnsForm',
    components: {
      CommercialForm,
      FormerAlert,
      PopupConfirm,
    },
    mixins: [former],
    data() {
      return {
        // A loja da regra que esta tela abriu, para o seletor conseguir mostrá-la
        // mesmo quando ela está fora da página de lojas que o campo carregou.
        selectedStore: null,
        sections: sections(),
        messageAlert: 'As regras aplicadas aqui irão determinar quais condições serão usadas nas simulações e propostas.',
        messagePopupConfirmation: '',
        popup: false,
      };
    },
    computed: {
      ...mapState([
        'financingReturnRules',
      ]),

      /*
       * A CHECAGEM DE SOBREPOSIÇÃO É PARTE DO SALVAR, e por isso conta como carregando: o
       * clique em "Salvar regra" dispara ela primeiro, e enquanto ela viaja a tela não
       * mostrava nada de ocupado - dava para começar uma remoção no meio de um
       * salvamento.
       */
      loading() {
        const {
          overlappings,
        } = this.financingReturnRules;

        return overlappings.loading
          || this.financingReturnRules[this.$route.params.rule_id ? 'update' : 'create'].loading;
      },

      overlappingRules() {
        return this.financingReturnRules.overlappings.result.financing_return_rules;
      },
    },
    mounted() {
      this.getReturn();

      this.setFieldValue(returnsMap.min_return, stringify(0));
      this.setFieldCallback(returnsMap.min_return, this.changedMinReturn);
      this.takeOutSeparatorFromSection('commercialAssociation');
    },
    methods: {
      /*
       * A LOJA VEM DO CAMINHO, e nos dois casos: criando, ela é o valor com que o campo
       * abre; editando, ela chega junto da regra e o `gotReturn` a repõe. Esta tela é de
       * UMA loja (`/stores/:id/commercial_control/returns/…`), então abrir o seletor vazio
       * pediria de novo uma escolha que já foi feita uma tela antes.
       *
       * O CAMPO CONTINUA EDITÁVEL de propósito: quem quiser criar a regra em outra loja
       * ainda pode, e o destino depois de salvar é a listagem da loja que ficou no campo -
       * não a do caminho.
       */
      getReturn() {
        const {
          id: storeID,
          rule_id: ruleID,
        } = this.$route.params;

        this.setFieldValue(storesMap.store_id, storeID);

        if (!ruleID) {
          // Criando não há regra, e a que sobrou de uma leitura anterior faria a tela
          // oferecer a remoção de OUTRA regra.
          this.$store.dispatch('financingReturnRules/clear', { action: 'read' });

          return;
        }

        this.setFieldProcessingBulk(commercialMap, true);
        this.setFieldProcessingBulk(returnsMap, true);

        this.$store
          .dispatch('financingReturnRules/read', { id: ruleID })
          .then(this.gotReturn);
      },
      gotReturn() {
        const {
          store,
          store_id: storeID,
          vehicle_model: vehicleModel,
          bank,
          max_return: maxReturn,
          min_return: minReturn,
          quota_preference: quotaPreference,
          return_preference: returnPreference,
        } = this.financingReturnRules.read.item;

        this.selectedStore = store;
        this.setFieldValue(storesMap.store_id, storeID);
        this.setFieldValue(commercialMap.has_bank, !!bank);
        this.setFieldValue(commercialMap.has_vehicle, !!vehicleModel);

        if (bank) {
          this.setFieldValue(commercialMap.bank_id, bank.id);
        }

        if (vehicleModel) {
          this.setFieldValue(commercialMap.vehicle_model_id, vehicleModel.id);
        }

        this.setFieldValue(returnsMap.max_return, stringify(maxReturn));
        this.setFieldValue(returnsMap.min_return, stringify(minReturn));
        this.setFieldValue(returnsMap.quota_preference, stringify(quotaPreference));
        this.setFieldValue(returnsMap.return_preference, stringify(returnPreference));

        this.setFieldProcessingBulk(commercialMap, false);
        this.setFieldProcessingBulk(returnsMap, false);
      },
      changedMinReturn() {
        const minReturn = this.getFieldValue(returnsMap.min_return);

        this.setFieldValidations(returnsMap.max_return, [{
          type: 'greaterThan',
          count: minReturn,
          equal: true,
        }]);
      },
      verifyOverlap() {
        // A REGRA, E NÃO A LOJA: `:id` no caminho é a loja desde que a área passou para
        // dentro dela, e quem identifica a regra é o `:rule_id`. Mandar o id da loja como
        // `not_id` fazia a regra sendo editada voltar como sobreposição dela mesma, e a
        // confirmação disparava em todo salvamento.
        const {
          rule_id: ruleId,
        } = this.$route.params;

        this.$store
          .dispatch('financingReturnRules/overlappings', {
            store_id: this.getFieldValue(storesMap.store_id),
            bank_id: this.getFieldValue(commercialMap.bank_id),
            vehicle_model_id: this.getFieldValue(commercialMap.vehicle_model_id),
            not_id: ruleId,
          })
          .then(this.verifyOverlapSuccess)
          .catch(this.submit);
      },
      verifyOverlapSuccess() {
        const {
          financing_return_rules: financingReturnRules,
        } = this.financingReturnRules.overlappings.result;

        if (financingReturnRules.length > 0) {
          this.popup = true;
          this.messagePopupConfirmation = financingReturnRules.length > 1
            ? 'A nova regra irá sobrepor as seguintes regras já cadastradas na loja '
            : 'A nova regra irá sobrepor a seguinte regra já cadastrada na loja';
        } else {
          this.submit();
        }
      },
      close() {
        this.popup = false;
      },
      submit() {
        const {
          rule_id: ruleID,
        } = this.$route.params;

        const payload = {
          store_id: this.getFieldValue(storesMap.store_id),
          bank_id: this.getFieldValue(commercialMap.bank_id),
          vehicle_model_id: this.getFieldValue(
            commercialMap.vehicle_model_id,
          ),
          min_return: this.getFieldValue(returnsMap.min_return),
          max_return: this.getFieldValue(returnsMap.max_return),
          quota_preference: this.getFieldValue(returnsMap.quota_preference),
          return_preference: this.getFieldValue(returnsMap.return_preference),
        };

        if (ruleID) {
          payload.id = ruleID;
        }

        this.$store
          .dispatch(`financingReturnRules/${ruleID ? 'update' : 'create'}`, payload)
          .then(this.submitSuccess)
          .catch(this.submitFailure);
      },
      // De volta à listagem DA LOJA em que a regra ficou - a do campo, não a do caminho:
      // quem trocou a loja no seletor quer ver a regra onde ela caiu.
      submitSuccess() {
        this.$router.push({
          name: 'stores-commercial-control-returns',
          params: {
            id: this.getFieldValue(storesMap.store_id),
          },
        });
      },
      // A regra removida: a loja é a dela, e quem a escolhe é o `Commercial/Form.vue`.
      removed(storeID) {
        this.$router.push({
          name: 'stores-commercial-control-returns',
          params: {
            id: storeID,
          },
        });
      },
      submitFailure() {
        const {
          error,
        } = this.financingReturnRules[this.$route.params.rule_id ? 'update' : 'create'];

        this.setErrors({
          ...storesMap,
          ...commercialMap,
          ...returnsMap,
        }, error);

        this.close();
        scrollHelper();
      },
      takeOutSeparatorFromSection(id) {
        const sectionToTakeOutSeparator = this.getSection(id);
        sectionToTakeOutSeparator.separator = false;
      },
      overlappingRuleText(rule, index) {
        const {
          bank,
          vehicle_model: vehicle,
        } = rule;

        const vehicleName = vehicle ? `${vehicle.name} ${vehicle.version}` : 'todos os veículos';
        const bankName = bank ? bank.tradename : 'todos os bancos';

        return `${index + 1}. Regra aplicada para ${vehicleName} - ${bankName}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .former-section-popup-message {
    text-align: center;
  }

  .former-section-popup-wrapper {
    align-items: center;
    background-color: $gray-light;
    border-radius: $button-small * 0.5;
    display: flex;
    flex-direction: column;
    margin: $gutter-bigger (-$gutter-small) 0;
    padding: $gutter-small;
    justify-content: center;
  }

  .former-section-popup-list-item {
    list-style: none;
    padding: $gutter-small;
  }

  .commercial-return-alert {
    margin-bottom: $gutter-bigger;
  }
</style>
